<div class="login-page">
  <form class="login-card" (ngSubmit)="submit()">
    <p class="brand">Studio CMMS</p>
    <h1>Accesso gestionale</h1>
    <p class="hint">Manutenzione macchinari odontotecnici</p>

    <label>
      Email
      <input type="email" [(ngModel)]="email" name="email" required autocomplete="username" />
    </label>
    <label>
      Password
      <input type="password" [(ngModel)]="password" name="password" required autocomplete="current-password" />
    </label>

    @if (error()) {
      <p class="error">{{ error() }}</p>
    }

    <button type="submit" [disabled]="loading()">
      {{ loading() ? 'Accesso…' : 'Entra' }}
    </button>
  </form>
</div>
